import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import EFChecked from '@/components/UI/svg/blade/calculator/EFChecked';
import { BladeCal } from '@/constants/blade';
import { createBladeCalculator, getBladeCalculator } from '@/service/calculator';

export default function Step5({ callBack, calObj }: any) {
    const { useState, useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('bladecalculator');
    const { locale } = useRouter();
    const [checked, setChecked] = useState(calObj?.check5 || 0);
    const [tip, setTip] = useState('');

    const MULTI_LAWN_ARR: any = [
        {
            img: (
                <NextImage
                    webpSrc={require('@publicLocal/blade/calculator/h5/cal_step5_1.webp')}
                    src={require('@publicLocal/blade/calculator/h5/cal_step5_1.png')}
                    alt={t('detail.calculator_step5_text1')}
                    aria-label={t('detail.calculator_step5_text1')}
                />
            ),
            text: t('detail.calculator_step5_text1'),
        },
        {
            img: (
                <NextImage
                    webpSrc={require('@publicLocal/blade/calculator/h5/cal_step5_2.webp')}
                    src={require('@publicLocal/blade/calculator/h5/cal_step5_2.png')}
                    alt={t('detail.calculator_step5_text2')}
                    aria-label={t('detail.calculator_step5_text2')}
                />
            ),
            text: t('detail.calculator_step5_text2'),
        },
        {
            img: (
                <NextImage
                    webpSrc={require('@publicLocal/blade/calculator/h5/cal_step5_3.webp')}
                    src={require('@publicLocal/blade/calculator/h5/cal_step5_3.png')}
                    alt={t('detail.calculator_step5_text3')}
                    aria-label={t('detail.calculator_step5_text3')}
                />
            ),
            text: t('detail.calculator_step5_text3'),
        },
    ];
    const handleCheck = (n: number) => {
        setChecked(n + 1);
        callBack({
            ...calObj,
            currentStep: 5,
            check5: n + 1,
        });
        // 手机端要求Next按钮滑上来
        const targetEl = document.querySelector('.step5 .step5-item.item-2') as HTMLLIElement;
        window.scrollTo({
            top: targetEl?.offsetTop - 20,
            behavior: 'smooth',
        });
    };
    const handleNext = async () => {
        window.scrollTo({
            top: 0,
        });
        const ids = [];
        try {
            const rules = await getBladeCalculator(locale);
            if (rules?.code === '0') {
                const rulesArr = rules?.data;

                const target1 = rulesArr?.find((item: any) => item.answerCode === `Q1_A${calObj?.check1}`);
                ids.push(target1?.id);

                calObj?.check2?.map((list: number) => {
                    const target2 = rulesArr?.find((item: any) => item.answerCode === `Q2_A${list}`);
                    ids.push(target2?.id);
                });

                calObj?.check3?.map((list: number) => {
                    const target3 = rulesArr?.find((item: any) => item.answerCode === `Q3_A${list}`);
                    ids.push(target3?.id);
                });

                if (calObj?.check4) {
                    const target4 = rulesArr?.find((item: any) => item.answerCode === `Q4_A${calObj?.check4}`);
                    ids.push(target4?.id);
                }

                const target5 = rulesArr?.find((item: any) => item.answerCode === `Q5_A${calObj?.check5}`);
                ids.push(target5?.id);
            } else {
                console.error(rules?.message);
            }
        } catch (e: any) {
            console.error(e);
        }
        try {
            const res = await createBladeCalculator(ids, locale);
            if (res?.code === '0') {
                callBack({ ...calObj, currentPage: BladeCal.Result, result: res?.data?.result, id: res?.data?.id });
                tip && setTip('');
            }
            if (res?.code !== '0') {
                console.error(res?.message);
                if (res?.message === 'Server is too busy') {
                    setTip(t('detail.calculator_result_tip'));
                } else {
                    setTip(res?.message);
                }
            }
        } catch (e: any) {
            console.error(e);
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'checklist_process5',
            step: 'Multiple Lawns',
            product_name: 'EcoFlow BLADE',
            button_name: 'Next',
            option_name: MULTI_LAWN_ARR[checked ? checked - 1 : checked]?.text,
        });
    };
    const handleBack = () => {
        window.scrollTo({
            top: 0,
        });
        setChecked(0);
        callBack({
            ...calObj,
            currentPage: calObj?.check4 ? BladeCal.Step4 : BladeCal.Step1,
            currentStep: calObj?.check4 ? 4 : 1,
            check5: undefined,
        });
    };
    return (
        <div className={`step5 ${css.step5}`}>
            <p className="step5-title">{t('detail.calculator_step5_title')}</p>
            <ul className="step5-box">
                {MULTI_LAWN_ARR?.map((shadow: any, k: number) => (
                    <li className={`step5-item item-${k}`} key={shadow?.text} onClick={() => handleCheck(k)}>
                        <div className="img-box">
                            {shadow?.img}
                            {checked === k + 1 && (
                                <>
                                    <div className="mask"></div>
                                    <EFChecked className="checked" />
                                </>
                            )}
                        </div>
                        <p className="img-text">{shadow?.text}</p>
                    </li>
                ))}
            </ul>
            <div className="step5-btns">
                <button className="btn-back" onClick={handleBack}>
                    {t('detail.calculator_btn_back')}
                </button>
                <button className="btn-next" disabled={!checked} onClick={handleNext}>
                    {t('detail.calculator_btn_next')}
                </button>
            </div>
            {tip && <p className="tip">{tip}</p>}
        </div>
    );
}
